//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import {} from '@data/user';
import UserHelpPerson from '@/views/user/components/UserHelpPerson.vue';
import UserHelpTeacher from '@/views/user/components/UserHelpTeacher.vue';
export default {
  name: 'user-help',
  components: {
    UserHelpTeacher: UserHelpTeacher,
    UserHelpPerson: UserHelpPerson
  },
  data: function data() {
    return {
      userVoNo: JSON.parse(window.localStorage.getItem('userInfo')) || {},
      roleVo: JSON.parse(window.localStorage.getItem('userRole')) || {}
    };
  },
  computed: {},
  created: function created() {},
  watch: {},
  beforeMount: function beforeMount() {},
  methods: {}
};